import React from 'react'

import HeaderTop from './HeaderTop'
import Menu from './Menu'

import HeaderMobile from './Mobile'

const Header = () => (
  <>
    <header 
      className="d-none d-lg-block"
      role="banner"
      aria-label="En-tête principal - Version desktop"
    >
      <HeaderTop />
      <Menu />
    </header>
    <div 
      className="d-lg-none"
      role="complementary"
      aria-label="En-tête principal - Version mobile"
    >
      <HeaderMobile />
    </div>
  </>
)

export default Header